import { render, staticRenderFns } from "./NonTransferables.vue?vue&type=template&id=7c38631d&"
import script from "./NonTransferables.vue?vue&type=script&lang=ts&"
export * from "./NonTransferables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports